"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserLogsMixin = void 0;

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vue = _interopRequireDefault(require("vue"));

var _vuexClass = require("vuex-class");

var _userLogs = require("@/api/user-logs.api");

var _vuePropertyDecorator = require("vue-property-decorator");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var UserLogsMixin = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(UserLogsMixin, _Vue);

  var _super = _createSuper(UserLogsMixin);

  function UserLogsMixin() {
    (0, _classCallCheck2.default)(this, UserLogsMixin);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(UserLogsMixin, [{
    key: "created",
    value: function created() {
      if (!this.userLogsAPI) {
        this.userLogsAPI = new _userLogs.UserLogsAPI();
      }
    }
  }, {
    key: "getLogs",
    value: function getLogs() {
      return this.userLogsAPI.getLogs({
        requestParameters: {
          userId: this.$userInformation['user']['name'] || ''
        }
      });
    }
  }, {
    key: "insertLogs",
    value: function insertLogs() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.userLogsAPI.insertLogs({
        payload: {
          userId: this.$userInformation && this.$userInformation['user'] && this.$userInformation['user']['name'] ? this.$userInformation['user']['name'] : '',
          customerId: this.$userData['id'] || '',
          message: message,
          data: data
        }
      });
    }
  }, {
    key: "insertLogInLogs",
    value: function insertLogInLogs() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.userLogsAPI.insertLogs({
        payload: {
          userId: data['user'] ? data['user'] : '',
          customerId: '',
          message: 'log in',
          data: data
        }
      });
    }
  }]);
  return UserLogsMixin;
}(_vue.default);

exports.UserLogsMixin = UserLogsMixin;
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], UserLogsMixin.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], UserLogsMixin.prototype, "$userData", void 0);
exports.UserLogsMixin = UserLogsMixin = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], UserLogsMixin);